import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white" dir="rtl">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-rose-50 via-pink-50 to-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 right-20 w-72 h-72 bg-rose-300 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 left-20 w-96 h-96 bg-pink-300 rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-800 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              قصة <span className="text-rose-400">Rose Mist</span>
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed">
              رحلة من الشغف بالجمال الطبيعي إلى علامة تجارية تثق بها آلاف النساء حول العالم
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="absolute -top-8 -right-8 w-64 h-64 bg-rose-100 rounded-full blur-3xl opacity-50"></div>
              <img 
                src="https://public.readdy.ai/ai/img_res/f43f666ddbbd031ac1a16f122ff998f5.jpg"
                alt="Rose Mist Story"
                className="relative rounded-3xl shadow-2xl w-full h-[700px] object-cover object-top"
              />
            </div>
            
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
                من نحن
              </h2>
              <div className="space-y-6 text-gray-600 leading-relaxed">
                <p>
                  <strong className="text-rose-400">Rose Mist</strong> ليست مجرد علامة تجارية للتجميل، بل هي فلسفة جمال تؤمن بأن كل امرأة تستحق أن تشعر بالثقة والجمال الطبيعي. بدأت رحلتنا من حلم بسيط: تقديم منتجات عناية فاخرة مصنوعة من مكونات طبيعية نقية.
                </p>
                <p>
                  نحن نؤمن بأن الجمال الحقيقي يبدأ من الداخل، ولهذا نختار بعناية فائقة كل مكون في منتجاتنا. من الزيوت العطرية النادرة إلى المستخلصات النباتية الطبيعية، كل عنصر يتم اختياره بحب وعناية لتقديم أفضل تجربة عناية لبشرتك.
                </p>
                <p>
                  اليوم، <strong className="text-rose-400">Rose Mist</strong> تفخر بخدمة أكثر من 10,000 عميلة حول العالم، وتقديم أكثر من 500 منتج متنوع يلبي جميع احتياجات العناية بالبشرة والجمال.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="py-20 bg-gradient-to-br from-rose-50 to-pink-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            <div className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-rose-100 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-eye-line text-3xl text-rose-400"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                رؤيتنا
              </h3>
              <p className="text-gray-600 leading-relaxed">
                أن نكون العلامة التجارية الأولى للجمال الطبيعي في العالم العربي، ونلهم كل امرأة لتحتفي بجمالها الفريد من خلال منتجات آمنة وفعالة ومستدامة.
              </p>
            </div>

            <div className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-rose-100 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-heart-line text-3xl text-rose-400"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                رسالتنا
              </h3>
              <p className="text-gray-600 leading-relaxed">
                تقديم منتجات عناية فاخرة مصنوعة من مكونات طبيعية نقية، مع الالتزام بأعلى معايير الجودة والشفافية، لنمنح كل امرأة تجربة جمال استثنائية تعزز ثقتها بنفسها.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Clean Beauty Values */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              قيم <span className="text-rose-400">الجمال النظيف</span>
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              نلتزم بمعايير صارمة لضمان أن كل منتج يحمل اسم Rose Mist آمن وفعال ومستدام
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center group">
              <div className="w-24 h-24 bg-gradient-to-br from-rose-100 to-pink-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-leaf-line text-4xl text-rose-400"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">مكونات طبيعية 100%</h3>
              <p className="text-gray-600 text-sm">
                نستخدم فقط مكونات طبيعية نقية خالية من المواد الكيميائية الضارة
              </p>
            </div>

            <div className="text-center group">
              <div className="w-24 h-24 bg-gradient-to-br from-rose-100 to-pink-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-test-tube-line text-4xl text-rose-400"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">غير مختبرة على الحيوانات</h3>
              <p className="text-gray-600 text-sm">
                نحن ضد التجارب على الحيوانات ونلتزم بمعايير الجمال الأخلاقي
              </p>
            </div>

            <div className="text-center group">
              <div className="w-24 h-24 bg-gradient-to-br from-rose-100 to-pink-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-recycle-line text-4xl text-rose-400"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">عبوات صديقة للبيئة</h3>
              <p className="text-gray-600 text-sm">
                نستخدم عبوات قابلة لإعادة التدوير لحماية كوكبنا
              </p>
            </div>

            <div className="text-center group">
              <div className="w-24 h-24 bg-gradient-to-br from-rose-100 to-pink-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-shield-check-line text-4xl text-rose-400"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">معتمدة عالمياً</h3>
              <p className="text-gray-600 text-sm">
                منتجاتنا حاصلة على شهادات الجودة العالمية والموافقات الصحية
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-gradient-to-br from-rose-50 to-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              فريق <span className="text-rose-400">الخبراء</span>
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              فريق من خبراء التجميل والعناية بالبشرة المتخصصين في تقديم أفضل الحلول لك
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow group">
              <div className="relative h-80 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20elegant%20female%20beauty%20expert%20consultant%20in%20soft%20pink%20blazer%2C%20confident%20smile%2C%20modern%20beauty%20clinic%20background%2C%20natural%20makeup%2C%20professional%20portrait%20photography%2C%20warm%20lighting%2C%20sophisticated%20feminine%20style&width=400&height=500&seq=team1&orientation=portrait"
                  alt="خبيرة التجميل"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-bold text-gray-800 mb-2">سارة أحمد</h3>
                <p className="text-rose-400 text-sm mb-3">خبيرة العناية بالبشرة</p>
                <p className="text-gray-600 text-sm">
                  15 عاماً من الخبرة في مجال العناية بالبشرة والتجميل الطبيعي
                </p>
              </div>
            </div>

            <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow group">
              <div className="relative h-80 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20elegant%20female%20makeup%20artist%20in%20soft%20pink%20outfit%2C%20friendly%20smile%2C%20beauty%20studio%20background%2C%20natural%20glowing%20makeup%2C%20professional%20portrait%20photography%2C%20soft%20lighting%2C%20modern%20feminine%20style&width=400&height=500&seq=team2&orientation=portrait"
                  alt="خبيرة المكياج"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-bold text-gray-800 mb-2">ليلى محمد</h3>
                <p className="text-rose-400 text-sm mb-3">خبيرة المكياج</p>
                <p className="text-gray-600 text-sm">
                  متخصصة في فنون المكياج الطبيعي والإطلالات العصرية
                </p>
              </div>
            </div>

            <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow group">
              <div className="relative h-80 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20elegant%20female%20beauty%20consultant%20in%20soft%20pink%20dress%2C%20warm%20smile%2C%20luxury%20beauty%20boutique%20background%2C%20minimal%20makeup%2C%20professional%20portrait%20photography%2C%20natural%20lighting%2C%20elegant%20feminine%20style&width=400&height=500&seq=team3&orientation=portrait"
                  alt="استشارية التجميل"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-bold text-gray-800 mb-2">نور خالد</h3>
                <p className="text-rose-400 text-sm mb-3">استشارية التجميل</p>
                <p className="text-gray-600 text-sm">
                  خبيرة في تقديم الاستشارات الشخصية لاختيار المنتجات المناسبة
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="bg-gradient-to-br from-rose-400 to-pink-400 rounded-3xl p-12 lg:p-16 text-center text-white relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-10 right-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
              <div className="absolute bottom-10 left-10 w-80 h-80 bg-white rounded-full blur-3xl"></div>
            </div>
            
            <div className="relative z-10">
              <h2 className="text-4xl lg:text-5xl font-bold mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
                انضمي إلى عائلة Rose Mist
              </h2>
              <p className="text-lg mb-8 max-w-2xl mx-auto opacity-90">
                اكتشفي مجموعتنا الحصرية من منتجات التجميل والعناية بالبشرة الطبيعية
              </p>
              <a 
                href="/shop" 
                className="inline-block bg-white text-rose-400 px-10 py-4 rounded-full font-bold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                تسوقي الآن
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
